"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceChangesEstimatedValues$ = exports.PriceChangesEstimatedValues$outboundSchema = exports.PriceChangesEstimatedValues$inboundSchema = void 0;
exports.priceChangesEstimatedValuesToJSON = priceChangesEstimatedValuesToJSON;
exports.priceChangesEstimatedValuesFromJSON = priceChangesEstimatedValuesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
/** @internal */
exports.PriceChangesEstimatedValues$inboundSchema = z.object({
    average_estimated_market_value: z.number().int(),
    average_estimated_market_value_rounded: z.number().int(),
    estimate_date: z.string().transform(v => new rfcdate_js_1.RFCDate(v)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_estimated_market_value": "averageEstimatedMarketValue",
        "average_estimated_market_value_rounded": "averageEstimatedMarketValueRounded",
        "estimate_date": "estimateDate",
    });
});
/** @internal */
exports.PriceChangesEstimatedValues$outboundSchema = z.object({
    averageEstimatedMarketValue: z.number().int(),
    averageEstimatedMarketValueRounded: z.number().int(),
    estimateDate: z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averageEstimatedMarketValue: "average_estimated_market_value",
        averageEstimatedMarketValueRounded: "average_estimated_market_value_rounded",
        estimateDate: "estimate_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PriceChangesEstimatedValues$;
(function (PriceChangesEstimatedValues$) {
    /** @deprecated use `PriceChangesEstimatedValues$inboundSchema` instead. */
    PriceChangesEstimatedValues$.inboundSchema = exports.PriceChangesEstimatedValues$inboundSchema;
    /** @deprecated use `PriceChangesEstimatedValues$outboundSchema` instead. */
    PriceChangesEstimatedValues$.outboundSchema = exports.PriceChangesEstimatedValues$outboundSchema;
})(PriceChangesEstimatedValues$ || (exports.PriceChangesEstimatedValues$ = PriceChangesEstimatedValues$ = {}));
function priceChangesEstimatedValuesToJSON(priceChangesEstimatedValues) {
    return JSON.stringify(exports.PriceChangesEstimatedValues$outboundSchema.parse(priceChangesEstimatedValues));
}
function priceChangesEstimatedValuesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PriceChangesEstimatedValues$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PriceChangesEstimatedValues' from JSON`);
}
//# sourceMappingURL=pricechangesestimatedvalues.js.map